import index from "./dictionary.vue";
export default index;
